import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import groupChecklist from './ContractChecklist.config';

import View from './ContractChecklist.view';

const ContractChecklist = ({
    grouping,
    handlePDFChecked,
    updateCheckedCount
}) => {
    const [checklist, setChecklist] = useState([]);

    useEffect(() => {
        const _checklist = groupChecklist[grouping].map(name => ({ name, isChecked: false }));
        setChecklist(_checklist);
    }, [grouping]);

    const handleChange = event => {
        const isChecked = event.target.checked;
        const name = event.target.name;
        const updatedChecklist = checklist.map(item => item.name !== name ? item : { name, isChecked });
        setChecklist(updatedChecklist);
        const checkedCount = updatedChecklist.filter(item => item.isChecked).length;
        updateCheckedCount(checkedCount);
    };
    const allChecked = checklist.length > 0 && checklist.filter(item => !item.isChecked).length === 0;

    return (
        <View
            checklist={checklist}
            allChecked={allChecked}
            handleChange={handleChange}
            handlePDFChecked={handlePDFChecked}
        />
    );

};

ContractChecklist.propTypes = {
    grouping: PropTypes.string.isRequired,
    handlePDFChecked: PropTypes.func.isRequired,
    updateCheckedCount: PropTypes.func.isRequired
}

export default ContractChecklist;